import { Address } from '../../interfaces/address';
import { Router } from '@angular/router';
import { WebSiteUsersService } from '../../services/webSiteUsers/webSiteUsers.service';
import { ToastrService } from 'ngx-toastr';
import { PdvService } from '../../services/pdv/pdv.service';
import { Component, Output, EventEmitter } from '@angular/core';
import { OrdersService } from '../../services/order/orders.service';
import { Subscription } from 'rxjs';
@Component({
    moduleId: module.id,
    selector: 'confirmation',
    templateUrl: 'confirmation.component.html',
    styleUrls: ['confirmation.component.scss']
})

export class ConfirmationComponent {
    loader: boolean = false;
    order: any;
    orderTypes: any[] = [];
    chosenOrderType: number;
    orderTypeLabel: string;
    orderErreurModePaimenet = false;
    orderProg: Date;
    payementModes: Array<any> = [];
    payamentmode = null;
    address: any = {};
    soon: boolean;
    subscriptions: Subscription[] = [];
    discount: number = 0;
    discountFrom: number = 0;
    @Output()
    onBack: EventEmitter<boolean> = new EventEmitter<boolean>();
    coupon = "";
    couponAdded = false;
    enablePayement = false;
    amountMiniDelivery: number;
    amountMiniMandatory: number;
    constructor(
        private pdvService: PdvService,
        private toastr: ToastrService,
        private orderService: OrdersService,
        private webSiteUsersService: WebSiteUsersService,
        private router: Router
    ) {

        this.getPdvMode();
        this.payamentmode = null;
        let subs1 = this.orderService.order.subscribe(
            (order) => {
                this.order = order;
                if (order.coupon) {
                    this.couponAdded = true;
                }
            }
        )
        let subs3 = this.orderService.address.subscribe((address: Address) => {
            this.address = address;
        });
        let subs5 = this.orderService.orderProg.subscribe((orderProg: Date) => {
            this.orderProg = orderProg;
        });
        let subs6 = this.orderService.chosenOrderType.subscribe((chosenOrderType: number) => {
            this.chosenOrderType = chosenOrderType;
            if (this.orderTypes.length > 1 && this.chosenOrderType > 0) {
                this.orderTypeLabel = this.orderTypes.filter(o => o.id == this.chosenOrderType)[0].label
            }
        });
        let subs2 = this.pdvService.orderTypes.subscribe((orderTypes: any[]) => {
            this.orderTypes = orderTypes;
            if (this.orderTypes.length > 0 && this.chosenOrderType > 0) {
                this.orderTypeLabel = this.orderTypes.filter(o => o.id == this.chosenOrderType)[0].label
            }
        });

        let subs7 = this.orderService.enablePayement.subscribe(
            (enablePayement) => {
                this.enablePayement = enablePayement
                if (!this.enablePayement) {
                    this.payamentmode = 2;
                }
            }
        );
        const subs8 = this.pdvService.pdv.subscribe(
            (data: any) => {
                this.amountMiniMandatory = data.amountMiniMandatory;
            }
        )
        const subs9 = this.orderService.amountMiniDelivery.subscribe(amountMiniDelivery => {
            this.amountMiniDelivery = amountMiniDelivery;
        });
        this.subscriptions.push(subs1, subs2, subs3, subs5, subs6, subs8, subs9, subs7);
    }

    getPdvMode() {
        this.pdvService.getPaymentModes().subscribe(
            (data: any[]) => {
                this.payementModes = data;
            }
        )
    }
    save() {
        if (this.chosenOrderType == 1) {
            if (Number(this.order.total) < Number(this.amountMiniDelivery) && this.amountMiniMandatory == 1) {
                this.toastr.error('', 'Minimum de livraison: ' + this.amountMiniDelivery + ' €');
            } else {
                this.continue();
            }
        } else {
            this.continue();
        }

    }

    continue() {
        if (this.payamentmode == 1 || this.payamentmode == 2) {
            if (this.payamentmode == 1) {
                this.order.payementModes = [{ id: 2, text: "CB" }];
                this.setOrder();
            } else {
                if (this.order.elements.length > 0 || this.order.menus.length > 0) {
                    this.order.payementModes = this.payementModes.filter(p => p.checked).map(p => ({ id: p.id, label: p.text }));
                    if (!this.order.payementModes || this.order.payementModes.length == 0) {
                        this.toastr.error('Sélectionnez un mode de réglement', 'Attention !');
                    } else {
                        this.setOrder();
                    }
                } else {
                    this.toastr.error('Votre panier est vide! merci de choisir un produit', 'Attention !');
                }
            }
        } else {
            this.toastr.error('Choisissez un mode de paiement', 'Attention !');
        }
    }
    setOrder() {
        this.order.user = '0';
        this.order.orderType = this.chosenOrderType;
        this.order.pdv = this.pdvService.idPdv;
        this.order.orderProg = this.orderProg.toString();
        this.loader = true;
        if (this.chosenOrderType == 1) {
            if (this.address.id) {
                this.webSiteUsersService.updateAddress(this.address).subscribe(
                    (da: any) => {
                        this.order.idAddress = this.address.id;
                        this.addOrder();
                    }, err => {
                        this.alertMessage(err)
                    }
                )
            } else {
                this.webSiteUsersService.addAddress(this.address).subscribe(
                    (da: any) => {
                        this.order.idAddress = da.id;
                        this.addOrder();
                    }, err => {
                        this.alertMessage(err)
                    }
                )
            }
        } else {
            this.addOrder();
        }
    }
    addOrder() {
        if (this.payamentmode == 1) {
            let amount = this.order.total;
            this.webSiteUsersService.getPayerId().subscribe(
                (payerId) => {
                    this.orderService.getPayementData({ amount, payerId }).subscribe(
                        (data: any) => {
                            this.validOrder(data.id, data.redirect_url);
                        }
                    )
                }, err => {
                    this.alertMessage(err)
                }

            )
        } else {
            this.validOrder();
        }
    }
    validOrder(transactionId = '', redirect_url = '') {
        setTimeout(
            () => {
                this.loader = true;
                this.order.transactionId = transactionId;
                this.order.payamentmode = this.payamentmode;
                this.orderService.addOrder(this.order).subscribe(
                    (data: any) => {
                        this.loader = false;
                        if (data.success) {
                            if (this.payamentmode == 2) {
                                this.orderService.clearOrder();
                                this.orderService.chosenOrderType.next(0);
                                this.orderService.address.next({
                                    id: null,
                                    address: "",
                                    city: "",
                                    postalCode: null,
                                    streetNumber: null,
                                    streetName: "",
                                });
                                this.router.navigate(['/commandes']);
                            } else {
                                window.location.href = redirect_url;
                            }
                        } else {
                            if (data.code == 2) {
                                let sub = this.pdvService.pdv.subscribe(
                                    (data) => {
                                        data.closeSite = true;
                                        this.toastr.error(data.closeComment, 'Attention!');
                                        this.pdvService.pdv.subscribe(data);
                                    }
                                )
                                sub.unsubscribe();
                            }
                            if (data.code == 3) {
                                this.toastr.error('Merci de consulter votre boite email pour valider votre inscription.', 'Validation de compte!');
                            }
                            if (data.code == 4) {
                                this.toastr.error('Votre compte a été désactivé par le restaurateur', 'Login');
                            }
                        }
                    },
                    (err) => {
                        this.alertMessage(err)
                    }
                )
            }, 100
        )
    }

    alertMessage(err) {
        let message = 'Erreur de serveur';
        if (err.error.message) {
            message = err.error.message;
        }
        this.toastr.error(message, "Erreur");
        this.loader = false;
    }

    back() {
        this.onBack.emit(true);
    }
    addCoupon() {
        if (!this.couponAdded) {
            if (!this.coupon) {
                this.toastr.error('Veuillez insérer votre code promo', 'Erreur')
            } else {
                this.orderService.checkCoupon(this.coupon).subscribe(
                    (data) => {
                        this.couponAdded = true;
                        this.orderService.addCoupon(data);
                    },
                    (err) => {
                        if (err.error.message) {
                            this.toastr.error(err.error.message, 'Erreur')
                        } else {
                            this.toastr.error("Erreur Serveur code : " + err.status + ",contacter l'Administrateur", 'Erreur')
                        }
                    }
                )
            }
        }
    }
    removeCoupon() {
        this.orderService.removeCoupon();
        this.couponAdded = false;
        this.coupon = "";
    }
    ngOnDestroy() {
        this.unsubscribe();
    }

    unsubscribe() {
        this.subscriptions.forEach((subscription: Subscription) => {
            subscription.unsubscribe();
        });
        this.subscriptions = [];
    }

}
